import type FetchError from '@atlassian/jira-fetch/src/utils/errors.tsx';

export const DELETE_COMPONENT_REQUEST = 'state.actions.DELETE_COMPONENT_REQUEST' as const;
export type DeleteComponentRequestAction = {
	type: typeof DELETE_COMPONENT_REQUEST;
};
export const deleteComponentRequest = (): DeleteComponentRequestAction => ({
	type: DELETE_COMPONENT_REQUEST,
});

// delete safe

export const DELETE_COMPONENT_SAFE = 'state.actions.DELETE_COMPONENT_SAFE' as const;
export type DeleteComponentSafeAction = {
	type: typeof DELETE_COMPONENT_SAFE;
};
export const deleteComponentSafe = (): DeleteComponentSafeAction => ({
	type: DELETE_COMPONENT_SAFE,
});

// delete confirmation

export const DELETE_COMPONENT_CONFIRMATION = 'state.actions.DELETE_COMPONENT_CONFIRMATION' as const;
export type DeleteComponentConfirmationAction = {
	type: typeof DELETE_COMPONENT_CONFIRMATION;
};
export const deleteComponentConfirmation = (): DeleteComponentConfirmationAction => ({
	type: DELETE_COMPONENT_CONFIRMATION,
});

// delete confirmed, do delete

export const DELETE_COMPONENT_CONFIRMED = 'state.actions.DELETE_COMPONENT_CONFIRMED' as const;
export type DeleteComponentConfirmedPayload = string | undefined;
export type DeleteComponentConfirmedAction = {
	type: typeof DELETE_COMPONENT_CONFIRMED;
	payload: DeleteComponentConfirmedPayload;
};
export const deleteComponentConfirmed = (
	payload: DeleteComponentConfirmedPayload,
): DeleteComponentConfirmedAction => ({
	type: DELETE_COMPONENT_CONFIRMED,
	payload,
});

// delete success

export const DELETE_COMPONENT_SUCCESS = 'state.actions.DELETE_COMPONENT_SUCCESS' as const;
export type DeleteComponentSuccessAction = {
	type: typeof DELETE_COMPONENT_SUCCESS;
};
export const deleteComponentSuccess = (): DeleteComponentSuccessAction => ({
	type: DELETE_COMPONENT_SUCCESS,
});

// delete fail

export const DELETE_COMPONENT_FAIL = 'state.actions.DELETE_COMPONENT_FAIL' as const;
export type DeleteComponentFailPayload = {
	error: FetchError;
};
export type DeleteComponentFailAction = {
	type: typeof DELETE_COMPONENT_FAIL;
	payload: DeleteComponentFailPayload;
};
export const deleteComponentFail = (
	payload: DeleteComponentFailPayload,
): DeleteComponentFailAction => ({
	type: DELETE_COMPONENT_FAIL,
	payload,
});

export const CANCEL = 'state.actions.CANCEL' as const;
export type CancelAction = {
	type: typeof CANCEL;
};
export const cancel = (): CancelAction => ({
	type: CANCEL,
});

export type Action =
	| DeleteComponentRequestAction
	| DeleteComponentSafeAction
	| DeleteComponentConfirmationAction
	| DeleteComponentConfirmedAction
	| DeleteComponentSuccessAction
	| DeleteComponentFailAction
	| CancelAction;
